import React, { useState, useEffect } from 'react';
import { useSearchkit, useSearchkitVariables } from '@searchkit/client';
import config from 'react-global-configuration';

import { FormikWrapper, FormSelect, ApiAutocomplete } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const RADIUS_DEFAULT = 5000;

const LocationSearch = ({ defaultValue, onChange }) => {
  const API_URL = config.get('API_URL');

  return (
    <div className="FormElement">
      <label htmlFor="LocationSearch">Locatie</label>
      <ApiAutocomplete
        key={`item--${defaultValue}`}
        id="LocationSearch"
        endpoint={`${API_URL}/autocomplete/json`}
        defaultValue={defaultValue}
        renderItem={(item) => {
          return <div className="LocationSearch__item">{item.name} <span className="LocationSearch__item__type">({item.type === "gemeente" ? "Gemeente" : "Plaats"})</span></div>;
        }}
        onSelectItem={(item) => {
          onChange(item);
        }}
        placeholder="Zoek een locatie"
      />
    </div>
  );
};

const Search = ({ initialValues }) => {
  const api = useSearchkit();
  const [area, setArea] = useState(initialValues.area);
  const [radius, setRadius] = useState(RADIUS_DEFAULT);
  const [bounds, setBounds] = useState(null);
  const [areaName, setAreaName] = useState(initialValues.area_name);

  const changeArea = (_area) => {
    if (!_area) {
      return;
    }

    setAreaName(_area.name);

    setArea({
      lat: _area.lat,
      lon: _area.lon,
    });

    setBounds({
      topLeft: {
        lat: _area.bounds.NE.lat,
        lon: _area.bounds.SW.long,
      },
      bottomRight: {
        lat: _area.bounds.SW.lat,
        lon: _area.bounds.NE.long,
      },
    });
  };

  const changeRadius = (_radius) => {
    if (_radius === 0) {
      setRadius(RADIUS_DEFAULT);
    } else {
      setRadius(_radius * 1000);
    }
  };

  useEffect(() => {
    if (area) {
      api.removeFiltersByIdentifier('radius');
      api.addFilter({
        identifier: "radius",
        geoRadius: {
          radius: radius || RADIUS_DEFAULT,
          center: {
            lat: area.lat,
            lon: area.lon,
          },
        },
      });
    }

    if (bounds) {
      api.removeFiltersByIdentifier('fake_box');
      api.addFilter({
        identifier: "fake_box",
        geoBoundingBox: bounds,
      });
    }

    if (areaName) {
      api.removeFiltersByIdentifier('area_name');
      api.addFilter({
        identifier: "area_name",
        value: areaName,
      });
    }

    api.setPage({ from: 0 });
    api.search();
  }, [api, radius, area, bounds, areaName]);

  return (
    <div className="Search">
      <FormikWrapper initialValues={initialValues}>
        <LocationSearch
          onChange={changeArea}
          defaultValue={areaName}
        />
        <FormSelect
          title="Afstand"
          fieldName="radius"
          placeholder="Kies een afstand"
          options={{
            0: '+ 0 km',
            1: '+ 1 km',
            2: '+ 2 km',
            3: '+ 3 km',
            4: '+ 4 km',
            5: '+ 5 km',
            8: '+ 8 km',
            10: '+ 10 km',
            15: '+ 15 km',
            30: '+ 30 km',
            100: '+ 100 km',
          }}
          onChange={changeRadius}
        />
      </FormikWrapper>
      <a href="/resultaten-op-naam" target="_parent" rel="noreferrer">of zoek op organisatienaam</a>
    </div>
  );
};

export default Search;
